import { render, staticRenderFns } from "./VaimoIconSVG.vue?vue&type=template&id=2afde926&scoped=true&"
import script from "./VaimoIconSVG.vue?vue&type=script&lang=ts&"
export * from "./VaimoIconSVG.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoIconSVG.vue?vue&type=style&index=0&id=2afde926&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afde926",
  null
  
)

export default component.exports